import {addToCart,normalizeBarcode,quantity,stockFor} from './domain.js';

// POS resolution never guesses by name: only an exact active GTIN or SKU.
// Ambiguous identifiers must be resolved by an operator.
export function resolvePosScan(products=[],raw=''){
  const code=normalizeBarcode(raw);
  if(!code)return {status:'empty',code};
  const matches=products.filter(p=>p.active!==false&&(
    (p.barcode&&normalizeBarcode(p.barcode)===code)||
    (p.sku&&normalizeBarcode(p.sku).toLowerCase()===code.toLowerCase())
  ));
  if(!matches.length)return {status:'missing',code};
  if(matches.length>1)return {status:'ambiguous',code,matches};
  return {status:'found',code,product:matches[0]};
}

// Guard before changing the local cart. Server checkout still revalidates
// stock, prices, tenant and idempotency (pdv_checkout_sale).
export function addScanWithStockGuard(cart,product,balances,locationId,allowNegative=false,operatorCart=false){
  if(!product||product.active===false||!product.id)return {status:'unavailable',cart};
  if(!Number.isSafeInteger(Number(product.price_cents))||Number(product.price_cents)<=0)
    return {status:'unpriced',cart};
  const current=cart.find(x=>x.product_id===product.id);
  const nextQty=quantity(current?.quantity||0)+1;
  const available=stockFor(balances,product.id,locationId);
  const insufficientStock=Boolean(product.track_inventory)&&nextQty>available;
  // Operator may stage a short-stock line locally for reconciliation.
  // This does not authorize checkout or bypass the server negative-stock rule.
  if(insufficientStock&&!allowNegative&&!operatorCart)
    return {status:'out_of_stock',cart,available};
  const next=addToCart(cart,product);
  if(next===cart||next===undefined||(!current&&!next.some(x=>x.product_id===product.id)))
    return {status:'cart_full',cart};
  return {status:'added',cart:next,quantity:nextQty,insufficientStock,available};
}
